/* eslint-disable prettier/prettier */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore"; 
import { auth, db } from "../../../firebase"; 

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  
  // State to track if the password is shown or hidden
  const [showPassword, setShowPassword] = useState(false); 
  
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    setError("");

    signInWithEmailAndPassword(auth, email, password)
      .then(async (userCredential) => {
        const userEmail = userCredential.user.email;
        
        try {
          const userDoc = await getDoc(doc(db, "users", userEmail));
          
          if (userDoc.exists()) {
            const userData = userDoc.data();
            
            localStorage.setItem("userRole", userData.role);
            localStorage.setItem("userEmail", userEmail);
            
            console.log("Logged in successfully as:", userData.role);
            navigate("/dashboard"); 
          } else {
            setError("هذا الحساب ليس لديه صلاحيات الدخول.");
            auth.signOut();
          }
        } catch (err) {
          console.error("Error fetching user data:", err);
          setError("حدث خطأ أثناء جلب الصلاحيات.");
        }
      })
      .catch((err) => {
        console.error("Login failed:", err.message);
        setError("فشل تسجيل الدخول. تأكد من البريد الإلكتروني وكلمة المرور.");
      });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div style={{ padding: "50px", textAlign: "center", direction: "rtl" }}>
      <h2>تسجيل دخول الإدارة</h2>
      <form onSubmit={handleLogin} style={{ display: "flex", flexDirection: "column", maxWidth: "300px", margin: "auto", gap: "15px" }}>
        {error && <p style={{ color: "red" }}>{error}</p>}
        
        <input 
          type="email" 
          placeholder="البريد الإلكتروني" 
          value={email} 
          onChange={(e) => setEmail(e.target.value)} 
          required 
          style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "5px" }} 
        />
        
        <div style={{ position: "relative", width: "100%", display: "flex" }}>
          <input 
            type={showPassword ? "text" : "password"} 
            placeholder="كلمة المرور" 
            value={password} 
            onChange={(e) => setPassword(e.target.value)} 
            required 
            style={{ padding: "10px", width: "100%", boxSizing: "border-box", border: "1px solid #ccc", borderRadius: "5px" }} 
          />
          <button 
            type="button" 
            onClick={togglePasswordVisibility}
            style={{
              position: "absolute",
              left: "10px", 
              top: "50%",
              transform: "translateY(-50%)",
              background: "none",
              border: "none",
              cursor: "pointer",
              color: "#666", // Professional gray color
              display: "flex",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            {/* 🟢 NEW: Professional SVG Icons instead of emojis */}
            {showPassword ? (
              /* Hide Password Icon (Eye with slash) */
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
              </svg>
            ) : (
              /* Show Password Icon (Normal Eye) */
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
            )} 
          </button>
        </div>

        <button type="submit" style={{ padding: "10px", background: "#333", color: "white", cursor: "pointer", borderRadius: "5px", border: "none", fontWeight: "bold" }}>دخول</button>
      </form>
    </div>
  );
}